"use client";
import { getProductCategories } from "@/app/actions/products";
import { ProductCategory } from "@/types/product";
import { useInfiniteQuery } from "@tanstack/react-query";
import React from "react";
import { Button } from "../ui/button";
import CategoryCard from "./category-card";

export default function CategoryList() {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    status,
    error,
  } = useInfiniteQuery({
    queryKey: ["product-categories"] as const,
    queryFn: getProductCategories,
    initialPageParam: null,
    getNextPageParam: (lastPage) => {
      if (lastPage?.pageInfo?.hasNextPage) {
        return lastPage?.pageInfo?.endCursor;
      }
      return undefined;
    },
  });

  return status === "pending" ? (
    <p>Loading...</p>
  ) : status === "error" ? (
    <p>Error: {error.message}</p>
  ) : (
    <>
      <section className="grid gap-6">
        {data.pages.map((group, i) => (
          <ul key={i} className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {group.edges.map(
              (product: { node: ProductCategory }, index: number) => {
                return (
                  <CategoryCard
                    key={product.node.id}
                    product={product.node}
                    index={index}
                  />
                );
              }
            )}
          </ul>
        ))}
        <div className="flex justify-center">
          {hasNextPage && (
            <Button
              onClick={() => fetchNextPage()}
              disabled={!hasNextPage || isFetchingNextPage}
            >
              {isFetchingNextPage
                ? "Laddar mer..."
                : hasNextPage
                ? "Ladda mer"
                : "Inga fler att ladda"}
            </Button>
          )}
        </div>
        <div>{isFetching && !isFetchingNextPage ? "Fetching..." : null}</div>
      </section>
    </>
  );
}
